import { DevicesFront, S_D_K } from "@project/shared-types";
import CryptoJS from "crypto-js";
import { UAParser } from "ua-parser-js";

export function encryptPayload(payload: DevicesFront): string {
  const json = JSON.stringify(payload);
  const ciphertext = CryptoJS.AES.encrypt(json, S_D_K).toString();
  return ciphertext;
}
async function isIncognito(): Promise<boolean> {
  try {
    const fs =
      (window as any).RequestFileSystem ||
      (window as any).webkitRequestFileSystem;
    if (!fs) return false;

    return new Promise((resolve) => {
      fs(
        0,
        100,
        () => resolve(false), // доступ дали — значит НЕ инкогнито
        () => resolve(true) // доступа нет — значит инкогнито
      );
    });
  } catch (error) {
    return false;
  }
}
function getDeviceType(): "mobile" | "tablet" | "desktop" {
  const width = window.innerWidth;
  if (/Mobi|Android/i.test(navigator.userAgent)) return "mobile";
  if (width >= 768 && width <= 1024) return "tablet";
  return "desktop";
}

export async function collectDeviceInfo(
  deviceId: string
): Promise<DevicesFront> {
  const parser = new UAParser();
  const ua = parser.getResult();

  const incognito = await isIncognito();

  return {
    device_id: deviceId,
    user_agent: navigator.userAgent,
    platform: ua.os.name || "unknown",
    device_type: getDeviceType(),
    browser_name: ua.browser.name || "unknown",
    browser_version: ua.browser.version || "unknown",
    language: navigator.language,
    timezone_offset: new Date().getTimezoneOffset(),
    screen_resolution: `${window.screen.width}x${window.screen.height}`,
    is_headless: navigator.webdriver || false,
    incognito,
    is_vpn: false,
  };
}
